import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  headingLevel: PropTypes.number,
  variants: PropTypes.arrayOf(PropTypes.oneOf(['white'])),
};

const defaultProps = {
  className: '',
  headingLevel: 4,
  variants: [],
};

function PreTitle({ title, className, headingLevel, variants }) {
  const variantClasses = variants.map(variant => `PreTitle--${variant}`);
  const classes = classNames(className, 'PreTitle', variantClasses);
  const Heading = `h${headingLevel}`;

  return (
    <Heading className={classes}>{title}</Heading>
  );
}

PreTitle.propTypes = propTypes;
PreTitle.defaultProps = defaultProps;

export default PreTitle;
